import React, { memo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { FileHistoryIcon } from '@sharedCR/coreDesignSystem/icons';
import ButtonWithTooltip from 'app/shared/components/common/ButtonWithTooltip';
import { DEFAULT_HISTORY_BUTTON_LABEL } from 'app/shared/modules/AuditHistoryDrawerButton/AuditHistoryDrawerButton.constants';
import PropTypes from 'prop-types';

import { COMPOSED_CLAIMS } from 'constants/composedClaims';
import { FormViewerNavigationType } from 'constants/forms';

import { selectIsClaimAllowed } from 'store/auth/selectors';
import { selectFormNavigationType } from 'store/forms/selectors';

import { FormChangeHistoryTestIds } from '../FormChangeHistory.testIds';
import FormChangeHistoryDrawer from '../FormChangeHistoryDrawer';

const FormChangeHistoryButton = ({ formId = null, formName = '', isGlobalForm = false }) => {
  const canViewHistory = useSelector(selectIsClaimAllowed(COMPOSED_CLAIMS.AUDIT_VIEW));
  const navigationType = useSelector(selectFormNavigationType);

  const [isOpen, setIsOpen] = useState(false);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);

  // Loan screens open forms with STATE navigation; those are loan-scoped forms, which the Forms
  // service never audits, so their history would always be empty.
  const isLoanScreen = navigationType === FormViewerNavigationType.STATE;

  if (isLoanScreen || !canViewHistory || !formId) {
    return null;
  }

  return (
    <>
      <ButtonWithTooltip
        dataTestId={FormChangeHistoryTestIds.BUTTON}
        icon={FileHistoryIcon}
        title={DEFAULT_HISTORY_BUTTON_LABEL}
        onClick={onOpen}
      />

      <FormChangeHistoryDrawer
        formId={formId}
        formName={formName}
        isGlobalForm={isGlobalForm}
        open={isOpen}
        onClose={onClose}
      />
    </>
  );
};

FormChangeHistoryButton.propTypes = {
  formId: PropTypes.string,
  formName: PropTypes.string,
  isGlobalForm: PropTypes.bool,
};

export default memo(FormChangeHistoryButton);
